import * as React from "react";
import { useState } from "react";
import { InternalChatListPanel } from "./InternalChatListPanel";
import { InternalChatListSearchView } from "./InternalChatListSearchView";
import { ChatListSearchAndFilter } from "../../ChatListSearchAndFilter";
import { GROUP_TYPE } from "@home-health-notify/domain";
import { FilteredInternalChatsContext } from "hhn-commons";

interface InternalChatsProps {
  selectedChatId?: string;
  unreadChatCount: number;
}

const InternalChats = ({
  selectedChatId,
  unreadChatCount,
}: InternalChatsProps) => {
  const [searchMode, setSearchMode] = useState(false);

  const showSearchPanel = (): void => setSearchMode(true);

  const showChatListPanel = (): void => setSearchMode(false);

  const { fetchChats, resetChats } = React.useContext(
    FilteredInternalChatsContext,
  );

  return (
    <>
      <ChatListSearchAndFilter
        showSearchPanel={showSearchPanel}
        showChatListPanel={showChatListPanel}
        groupType={GROUP_TYPE.NON_PATIENT}
        fetchChats={fetchChats}
        resetChats={resetChats}
      />
      {!searchMode ? (
        <InternalChatListPanel
          selectedChatId={selectedChatId}
          unreadChatCount={unreadChatCount}
        />
      ) : (
        <InternalChatListSearchView selectedChatId={selectedChatId} />
      )}
    </>
  );
};
export default InternalChats;
